// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"_33974c2b58--tooltip--iKIv0","arrow_tooltip":"_33974c2b58--arrow_tooltip--FnHui","arrow":"_33974c2b58--arrow--M3H38"};